import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Customer } from '../../../models/customer/customer';
import { AddCustomerMode } from '../add-customer/add-customer.component';

@Component({
  selector: 'app-add-customer-dialog',
  templateUrl: './add-customer-dialog.component.html',
  standalone: false,
})
export class AddCustomerDialogComponent {
  merchantId: string | undefined;
  customer: Partial<Customer> | undefined;
  mode: AddCustomerMode = 'add';

  constructor(
    public dialogRef: MatDialogRef<AddCustomerDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      merchantId: string;
      customer?: Partial<Customer>;
      mode: AddCustomerMode;
    },
  ) {

    this.merchantId = data.merchantId;
    this.customer = data.customer;
    this.mode = data.mode;
  }

  ngOnInit() {}

  handleCustomerSaved(customer: Partial<Customer>) {
    this.dialogRef.close(customer);
  }
}
